import { Box, IconList, Image, Stack, Text, TextLink } from '@eneco/sparky';
import { CheckIcon } from '@eneco/sparky/icons';
import { mapImage, usePlaceholderContent } from '@sitecore/common';
import { ServiceGemakFlowContactRendering } from '@sitecore/types/ServiceGemakFlowContact';

const Footer = () => {
  const { ServiceGemakFlowContact: { fields: textualData } = {} } = usePlaceholderContent<{
    ServiceGemakFlowContact: ServiceGemakFlowContactRendering;
  }>();

  const footerImg = mapImage(textualData?.content.image);

  return (
    <Stack direction="row" alignX={{ initial: 'start', sm: 'center' }}>
      <Box as="div" backgroundColor="backgroundPrimary" borderRadius="m" padding="8">
        <Stack direction="row" alignY="center" alignX="center" gap={{ sm: '3', md: '6' }}>
          <Box>
            <Box paddingBottom={2}>
              <Text weight="bold">{textualData?.content?.title.value}</Text>
              <Text>{textualData?.content?.text.value}</Text>
            </Box>
            <IconList>
              <IconList.Item
                key={textualData?.content?.contactInformationList?.value?.enum[0]?.value}
                icon={<CheckIcon color="feedbackSuccess" />}>
                <TextLink href={`tel:${textualData?.content?.contactInformationList?.value?.enum[0]?.label}`}>
                  {textualData?.content?.contactInformationList?.value?.enum[0]?.label}
                </TextLink>
              </IconList.Item>
              <IconList.Item
                key={textualData?.content?.contactInformationList?.value?.enum[1]?.value}
                icon={<CheckIcon color="feedbackSuccess" />}>
                {textualData?.content?.contactInformationList?.value?.enum[1]?.label}
              </IconList.Item>
            </IconList>
          </Box>
          <Image
            maxWidth="80px"
            height="80px"
            src={footerImg?.src ?? ''}
            sources={footerImg?.sources}
            alt={footerImg?.alt}
          />
        </Stack>
      </Box>
    </Stack>
  );
};

export default Footer;
